import { Component } from '@angular/core';

import { Subscription } from 'rxjs';

import { BaseComponent } from '../_base.component';

import { DialogBaseService } from '../../../../dialog/dialog.base.service';

import { InputColorPickerModal } from './color-picker.modal';

/**
 * @ignore
 */
@Component({
  selector: 'uex-input-color',
  templateUrl: './color.component.html',
  host: {
    class: 'uex-input-color'
  }
})
export class InputColorComponent extends BaseComponent<string> {
  constructor(
    private _dialogBaseService: DialogBaseService
  ) { super(); }

  public picker_value: string = null;
  public modal_opened = false;

  public onPickerFocus() {
    this.modal_opened = true;
    if (!this.isFocused()) { this.schema.focus(); }
    const dialog = this._dialogBaseService.open(InputColorPickerModal, {
      schema: this.schema,
      form: this.form
    });
    const value_subscription: Subscription = dialog.onReturnValue.subscribe((value) => {
      value_subscription.unsubscribe();
      this.schema.value = value || null;
      this.onChange();
      dialog.close();
    });
    dialog.onClose.then(() => {
      this.modal_opened = false;
      this.schema.focus();
    });
  }

  public onColorChange() {
    this.schema.value = this.picker_value || null;
    this.onChange();
  }
}
